import "./style.css";
import ButtonLoader from "./ButtonLoader";
import Stroke1 from "../../Assets/icon/Stroke1.svg";

const ContentLoader = () => {
  return (
    <div className="loader-df-container">
      {/* Decorative stroke layers */}
      <img src={Stroke1} alt="Stroke Layer 1" className="stroke-1-loader" />
      <img src={Stroke1} alt="Stroke Layer 2" className="stroke-2-loader" />
      <img src={Stroke1} alt="Stroke Layer 3" className="stroke-3-loader" />
      <img src={Stroke1} alt="Stroke Layer 4" className="stroke-4-loader" />
      <img src={Stroke1} alt="Stroke Layer 5" className="stroke-5-loader" />
      <img src={Stroke1} alt="Stroke Layer 6" className="stroke-6-loader" />

      {/* Spinner */}
      <ButtonLoader
        type="spinner-cub"
        bgColor={"#2D50A7"}
        color={"#3D6DEB"}
        size={45}
      />
    </div>
  );
};

export default ContentLoader;
